<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <label class="label">เลขทะเบียน:</label>
                  <span class="form-control-plaintext">{{ treCarReg }}</span>
                </div>
              </div>
              <div class="col-xl-12">
                <div class="form-group">
                  <label class>ประเภทบริษัท:</label>
                  <span class="form-control-plaintext">{{
                    treCompanyType
                  }}</span>
                </div>
              </div>
              <div class="col-xl-12">
                <div class="form-group">
                  <label class="label">บริษัท:</label>
                  <span class="form-control-plaintext">{{
                    treCompanyName
                  }}</span>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label class="label-required">ชื่อคนขับ:</label>
                  <input
                    id="treDriverFirstName"
                    name="treDriverFirstName"
                    v-model="treDriverFirstName"
                    type="text"
                    maxlength="256"
                    class="form-control"
                    placeholder="ชื่อ"
                  />
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label class="label-required">นามสกุล</label>
                  <input
                    id="treDriverLastName"
                    name="treDriverLastName"
                    v-model="treDriverLastName"
                    type="text"
                    maxlength="256"
                    class="form-control"
                    placeholder="นามสกุล"
                  />
                </div>
              </div>
              <div class="col-xl-12">
                <div class="form-group">
                  <label class="label-required">เบอร์ติดต่อ:</label>
                  <input
                    id="treDriverTel"
                    name="treDriverTel"
                    v-model="treDriverTel"
                    type="text"
                    maxlength="256"
                    class="form-control"
                    placeholder="เบอร์ติดต่อ"
                  />
                </div>
              </div>
              <div class="row col-xl-12 w3-container">
                <div class="col-xl-6">
                  <div class="form-group">
                    <label class="label-required"
                      >ผู้ประสานงาน(Boonrawd):</label
                    >
                    <select2
                      :css-style="'width: 100%;'"
                      :css-class="'form-control'"
                      :id="'treEmpId'"
                      :name="'treEmpId'"
                      :select2-options="treEmpIdOptions"
                      @selectChange="onTreEmpIdChange"
                      v-model="treEmpId"
                      ref="treEmpIdSelect2"
                    ></select2>
                    <span class="form-text"></span>
                  </div>
                </div>
                <div class="col-xl-6">
                  <div class="form-group">
                    <label class="label">เบอร์ติดต่อ:</label>
                    <input
                      id="treEmpTel"
                      name="treEmpTel"
                      v-model="treEmpTel"
                      type="text"
                      maxlength="256"
                      class="form-control"
                      placeholder="เบอร์ติดต่อ"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-xl-6">
                  <div class="form-group">
                    <label class="label">อีเมล:</label>
                    <input
                      id="treEmpEmail"
                      name="treEmpEmail"
                      v-model="treEmpEmail"
                      type="text"
                      maxlength="256"
                      class="form-control"
                      placeholder="อีเมล"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-xl-6">
                  <div class="form-group">
                    <label class="label">ตำแหน่ง:</label>
                    <input
                      id="treEmpPosition"
                      name="treEmpPosition"
                      v-model="treEmpPosition"
                      type="text"
                      maxlength="256"
                      class="form-control"
                      placeholder="ตำแหน่ง"
                      readonly
                    />
                  </div>
                </div>
              </div>
              <div class="row col-xl-12 w3-container">
                <div class="col-xl-6">
                  <div class="form-group">
                    <label class="label-required">ผู้ประสานงาน(ภายนอก):</label>
                    <select2
                      :css-style="'width: 100%;'"
                      :css-class="'form-control'"
                      :id="'treTransitContactorId'"
                      :name="'treTransitContactorId'"
                      :select2-options="treTransitContactorIdOptions"
                      @selectChange="onTreTransitContactorIdChange"
                      v-model="treTransitContactorId"
                      ref="treTransitContactorIdSelect2"
                    ></select2>
                    <span class="form-text"></span>
                  </div>
                </div>
                <div class="col-xl-6">
                  <div class="form-group">
                    <label class="label">เบอร์ติดต่อ:</label>
                    <input
                      id="treTransitContactorTel"
                      name="treTransitContactorTel"
                      v-model="treTransitContactorTel"
                      type="text"
                      maxlength="256"
                      class="form-control"
                      placeholder="เบอร์ติดต่อ"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-xl-6">
                  <div class="form-group">
                    <label class="label">อีเมล:</label>
                    <input
                      id="treTransitContactorEmail"
                      name="treTransitContactorEmail"
                      v-model="treTransitContactorEmail"
                      type="text"
                      maxlength="256"
                      class="form-control"
                      placeholder="อีเมล"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-xl-6">
                  <div class="form-group">
                    <label class="label">ตำแหน่ง:</label>
                    <input
                      id="treTransitContactorPosition"
                      name="treTransitContactorPosition"
                      v-model="treTransitContactorPosition"
                      type="text"
                      maxlength="256"
                      class="form-control"
                      placeholder="ตำแหน่ง"
                      readonly
                    />
                  </div>
                </div>
              </div>
              <div class="col-xl-12">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <div class="form-check">
                    <label class="form-check-label kt-checkbox">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        name="treInActiveStatus"
                        id="treInActiveStatus"
                        v-model="treInActiveStatus"
                      />
                      <span></span>
                      เปิดใช้งาน
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="kt-portlet__foot">
        <button type="button" class="btn btn-secondary" @click="$router.go(-1)">
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="submit" class="btn btn-primary">
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";

export default {
  components: {
    select2,
  },
  data() {
    var self = this;

    return {
      trasitId: null,
      treCarReg: null,
      treCompanyType: null,
      treCompanyId: null,
      treCompanyName: null,
      treDriverFirstName: null,
      treDriverLastName: null,
      treDriverTel: null,
      treTransitContactorId: null,
      treEmpId: null,
      treInActiveStatus: null,
      treEmpTel: null,
      treEmpEmail: null,
      treEmpPosition: null,
      treTransitContactorTel: null,
      treTransitContactorEmail: null,
      treTransitContactorPosition: null,
      treEmpIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Employee/Select2Employee",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      treTransitContactorIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/TransitContactor/Select2TransitContactor",
          data: function(params) {
            var tmp = "";
            if (self.treCompanyType == "agent") {
              tmp = self.treCompanyId;
            } else if (self.treCompanyType == "vendor") {
              tmp = self.treCompanyId;
            }

            var query = {
              search: params.term,
              page: params.page || 1,
              companyType: self.treCompanyType,
              companyId: tmp,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    formSubmit: function(e) {
      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      let router = this.$router;
      let self = this;

      if (this.trcCompanyType == "Agent") {
        this.treCompanyType = "agent";
      } else if (this.trcCompanyType == "Vendor") {
        this.treCompanyType = "vendor";
      }
      axios
        .put("/Api/Transport", {
          TransitId: this.trasitId,
          CarReg: this.treCarReg,
          CompanyType: this.treCompanyType,
          CompanyId: this.treCompanyId,
          DriverFirstName: this.treDriverFirstName,
          DriverLastName: this.treDriverLastName,
          DriverTel: this.treDriverTel,
          TransitContactorId: this.treTransitContactorId,
          EmpId: this.treEmpId,
          InActiveStatus: !this.treInActiveStatus,
        })
        .then(function(response) {
          if (response.data.status) {
            KTApp.unblockPage();
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    onTreEmpIdChange: function(id, text, data, ref) {
      this.treEmpEmail = data[0].data.email;
      this.treEmpTel = data[0].data.officeTel;
      this.treEmpPosition = data[0].data.positionName;
    },
    onTreTransitContactorIdChange: function(id, text, data, ref) {
      this.treTransitContactorEmail = data[0].data.email;
      this.treTransitContactorTel = data[0].data.tel;
      this.treTransitContactorPosition = data[0].data.position;
    },
  },

  async mounted() {
    let self = this;
    let router = this.$router;
    axios
      .get("/Api/Transport/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          self.trasitId = response.data.trasitId;
          self.treCarReg = response.data.carReg;
          if (response.data.companyType == "agent") {
            self.treCompanyType = "agent";
          }
          else if(response.data.companyType == "vendor")
          {
            self.treCompanyType = "Supplier"
          }
          else {
            self.treCompanyType = "vendor";
          }
          self.treInActiveStatus = !response.data.inActiveStatus;
          self.treCompanyId = response.data.companyCode;
          self.treCompanyName = response.data.companyName;
          self.treDriverFirstName = response.data.driverName;
          self.treDriverLastName = response.data.driverLastName;
          self.treDriverTel = response.data.driverTel;
          self.treTransitContactorTel = response.data.contactTel;
          self.treTransitContactorEmail = response.data.contactEmail;
          self.treTransitContactorPosition = response.data.contactPosition;
          self.treEmpTel = response.data.employeeTel;
          self.treEmpEmail = response.data.employeeEmail;
          self.treEmpPosition = response.data.employeePosName;
          if (response.data.employeeId) {
            self.$refs.treEmpIdSelect2.setSelectedData({
              id: response.data.employeeId,
              text:
                "[" +
                response.data.employeeNO +
                "] " +
                response.data.employeeName +
                " " +
                response.data.employeeLastName,
              data: {
                email: response.data.employeeEmail,
                positionName: response.data.employeePosName,
                officeTel: response.data.employeeTel,
              },
            });
          }
          if (response.data.transitContactorId) {
            self.$refs.treTransitContactorIdSelect2.setSelectedData({
              id: response.data.transitContactorId,
              text:
                response.data.contactName + " " + response.data.contactLastname,
              data: {
                email: response.data.contactEmail,
                position: response.data.contactPosition,
                tel: response.data.contactTel,
              },
            });
          }
        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลขนส่งคุณเลือก", "warning");
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลขนส่งได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });

    // set validation rules
    $(this.$refs.form).validate({
      rules: {
        treDriverFirstName: "required",
        treDriverLastName: "required",
        treDriverTel: "required",
        treTransitContactorId: "required",
        treEmpId: "required",
      },
      messages: {
        treDriverFirstName: "กรุณากรอกชื่อคนขับ",
        treDriverLastName: "กรุณากรอกนามสกุล",
        treDriverTel: "กรุณากรอกเบอร์ติดต่อ",
        treTransitContactorId: "กรุณาเลือกผู้ประสานงาน(ภายนอก)",
        treEmpId: "กรุณาเลือกผู้ประสานงาน(Boonrawd)",
      },
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>



// WEBPACK FOOTER //
// App/Components/Master/Transport/EditTransport.vue